<template>
  <div >
      <new-verification v-if="application" :initApplication="application" />
      <div v-else class="col-md-12" >  
        <div class="row">

          <div v-loading="true" element-loading-spinner="qc-spinner" class="col-md-12 card" :data-background-color="'info'">
            <div class="card-header">
                <h4 class="card-title">Qualification Verification for your application to the organisation.</h4>
            </div>
            <div class="card-content col-md-12" style="float:none">
              <div>
                <p>Please complete your application which will be shared along with your verification results to the organisation.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
  import NewVerification from 'src/views/Verifications/multi/New'
  
  export default {
    name: "start-application",
    components: {
      'new-verification': NewVerification
    },
    props: {
    },
    data () {
      return {
        loadingApplication: false,
        application: null
      }
    },
    mounted() {
      this.loadingApplication = true
      this.$store.commit('setApplicationInProgress',  this.$route.params.id)
      this.$api.getApplication(this.$route.params.id)
        .then(response => {
            this.application = response.data
            this.loadingApplication = false
          }).catch(error => {
            console.log(error)
            this.loadingApplication = false
          })
    },
    destroyed() {
      this.$store.commit('setApplicationInProgress', null)
    },
    computed: {

    },
    methods: {

    }
  }
</script>

<style>

</style>